import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  apiEndPoint = environment.apiEndPoint;
  constructor(private msalService: MsalService,
              private httpClient: HttpClient) { 
            
  }
  get isLogged(){
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  logout(){
    console.log('LOGOUT REDIRECTION TO: ', environment.msalConfig.auth.postLogoutRedirectUri)
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri
    });
  }
}
